import {BaseSchemaDataModel, BaseSchemaModel} from "./base-schema-model";
import {SCHEMA_TYPE} from "./consts";
import {LocationSchemaModel} from "./location-schema-model";
import {CompetitorLogoParams} from "../../../domain/common/competitor/models/competitor-logo-params";
import {PersonSchemaModel} from "./person-schema-model";

export class SportTeamSchemaDataModel extends BaseSchemaDataModel {
  id: Number;
  sport: String;
  location: LocationSchemaModel;
  logo: CompetitorLogoParams;
  coach: Array<PersonSchemaModel>;
  athlete: Array<PersonSchemaModel>;
}

export class SportTeamSchemaModel extends BaseSchemaModel {
  model: SportTeamSchemaDataModel;

  constructor(model: SportTeamSchemaModel) {
    super(SCHEMA_TYPE.sportsTeam, model.name, model.url);

    this.model = model;
  }

  get sportParams(): String {
    return this.model.sport ? `,"sport": "${this.model.sport}"` : '';
  }

  get logoParams(): String {
    return this.model.logo ? `,"logo": "${this.model.logo.toString()}"` : '';
  }

  get locationParams(): String {
    return this.model.location ? `,"location": [${this.model.location.toString()}]` : '';
  }

  get coachParams(): String {
    return this.model.coach ? `,"coach": [${this.model.coach?.map((person: PersonSchemaModel) => `{${person.toString()}}`)}]` : '';
  }

  get athleteParams(): String {
    return this.model.athlete?.length > 0 ? `,"athlete": [${this.model.athlete?.map((person: PersonSchemaModel) => `{${person.toString()}}`)}]` : '';
  }

  toString(): String {
    return `${super.toString()}${this.sportParams}${this.logoParams}${this.locationParams}${this.coachParams}${this.athleteParams}`;
  }
}
